import { FC } from 'react';
import { Snackbar as MuiSnackbar, Alert } from '@mui/material';
import { useSnackbar } from '@carcareers/contexts';

export const Snackbar: FC = () => {
  const { message, severity, open, toggleSnackbar } = useSnackbar();

  const handleClose = () => {
    toggleSnackbar();
  };

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
